const CHECKBOX_CLASS =
  "mt-0.5 h-4 w-4 shrink-0 rounded-none border-zinc-400 text-zinc-900 focus:ring-2 focus:ring-zinc-900 disabled:opacity-50";

/**
 * A start of the collection sends the agent a message, and the chat box is
 * closed while the agent works. So a message that the person typed in the chat
 * box and did not send can go with the start, or stay in the box.
 */
export const UnsentChatMessage = ({
  text,
  send,
  disabled = false,
  onSendChange,
}: {
  text: string;
  send: boolean;
  disabled?: boolean;
  onSendChange: (send: boolean) => void;
}) => (
  <div className="mt-4 space-y-2 rounded-[3px] border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900">
    <p className="font-medium">Your chat box has a message that you did not send:</p>
    <p className="line-clamp-4 whitespace-pre-wrap break-words border-l-2 border-amber-300 pl-2">
      {text}
    </p>
    <label className="flex items-start gap-2">
      <input
        type="checkbox"
        checked={send}
        disabled={disabled}
        onChange={(event) => onSendChange(event.target.checked)}
        className={CHECKBOX_CLASS}
      />
      <span>
        Send it to the agent with the start, so that the agent uses it.
        <span className="block text-xs text-amber-800">
          When you do not send it, it stays in the chat box. You can send it when the agent
          stops.
        </span>
      </span>
    </label>
  </div>
);
